import React from "react";

import { Container } from "../../globalStyles";
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapperReferenzenNoPadding,
  TextWrapper,
  Heading,
  Subtitle,
  ImgWrapper,
  Img,
} from "../InfoSection/InfoSection.elements";
import img from "../../images/aboutUs-svg.webp";
import Partners from "./SliderPartners";



function AboutUsSection() {
  return (
    <div id='überuns'>
      <InfoSec>
        <Container>
          <InfoRow imgStart>
            <InfoColumn>
              <TextWrapper>
                <Heading>Über uns</Heading>
                <Subtitle>
                  <p>
                    Wir sind ein junges, zuverlässiges und vertrauenswürdiges
                    Reinigungsteam.
                  </p>
                  <br />
                  <p>
                    Milas-SauberZauber ist Ihr Ansprechspartner für Reinigungen
                    in der Region Bern, Bern-Mittelland und Emmental.
                  </p>
                  <br />
                  <p>
                    Zufriedene Kunden sind unser oberstes Ziel, welches wir
                    durch unsere Qualität, herrvorragendes
                    Preis-Leistungs-Verhältnis und korrektes Verhalten gegenüber
                    Kunden erreichen.
                  </p>
                </Subtitle>
              </TextWrapper>
            </InfoColumn>
            <InfoColumn>
              <ImgWrapper>
                <Img src={img} alt='img' />
              </ImgWrapper>
            </InfoColumn>
          </InfoRow>
          <TextWrapperReferenzenNoPadding>
            <Heading>Referenzen</Heading>

            <Partners />
          </TextWrapperReferenzenNoPadding>
        </Container>
      </InfoSec>
    </div>
  );
}

export default AboutUsSection;
